(() => {
  const mobileQuery = window.matchMedia('(max-width: 767.98px)');

  const initShowcaseStacks = (scope = document) => {
    scope.querySelectorAll('[data-iine-showcase-stack]').forEach((carousel) => {
      if (carousel.dataset.iineShowcaseReady === 'true') return;

      const cards = [...carousel.querySelectorAll('[data-iine-showcase-card]')];
      const dots = [...carousel.querySelectorAll('[data-iine-showcase-dot]')];
      const previous = carousel.querySelector('[data-iine-showcase-prev]');
      const next = carousel.querySelector('[data-iine-showcase-next]');
      if (!cards.length) return;

      let activeIndex = 0;
      let autoplayTimer = 0;
      let pointerStartX = null;
      let inView = !('IntersectionObserver' in window);
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const wrapIndex = (index) => (index + cards.length) % cards.length;

      const render = () => {
        if (!mobileQuery.matches) {
          cards.forEach((card) => {
            card.classList.remove('is-active', 'is-prev', 'is-next');
            card.removeAttribute('aria-hidden');
            card.querySelectorAll('a, button').forEach((control) => control.removeAttribute('tabindex'));
          });
          return;
        }

        const previousIndex = wrapIndex(activeIndex - 1);
        const nextIndex = wrapIndex(activeIndex + 1);
        cards.forEach((card, index) => {
          const isActive = index === activeIndex;
          card.classList.toggle('is-active', isActive);
          card.classList.toggle('is-prev', cards.length > 1 && index === previousIndex);
          card.classList.toggle('is-next', cards.length > 1 && index === nextIndex);
          card.setAttribute('aria-hidden', String(!isActive));
          card.querySelectorAll('a, button').forEach((control) => {
            if (isActive) control.removeAttribute('tabindex');
            else control.setAttribute('tabindex', '-1');
          });
        });
        dots.forEach((dot, index) => {
          const isActive = index === activeIndex;
          dot.classList.toggle('is-active', isActive);
          if (isActive) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      };

      const stopAutoplay = () => window.clearTimeout(autoplayTimer);
      const scheduleAutoplay = () => {
        stopAutoplay();
        if (!mobileQuery.matches || reducedMotion || !inView || document.hidden || cards.length < 2) return;
        autoplayTimer = window.setTimeout(() => {
          activeIndex = wrapIndex(activeIndex + 1);
          render();
          scheduleAutoplay();
        }, 4800);
      };

      const goTo = (index) => {
        activeIndex = wrapIndex(index);
        render();
        scheduleAutoplay();
      };

      previous?.addEventListener('click', () => goTo(activeIndex - 1));
      next?.addEventListener('click', () => goTo(activeIndex + 1));
      dots.forEach((dot, index) => dot.addEventListener('click', () => goTo(index)));

      carousel.addEventListener('pointerdown', (event) => {
        if (!mobileQuery.matches || event.pointerType === 'mouse') return;
        pointerStartX = event.clientX;
        stopAutoplay();
      }, { passive: true });

      carousel.addEventListener('pointerup', (event) => {
        if (pointerStartX === null) return;
        const distance = event.clientX - pointerStartX;
        pointerStartX = null;
        if (Math.abs(distance) >= 42) goTo(activeIndex + (distance < 0 ? 1 : -1));
        else scheduleAutoplay();
      }, { passive: true });

      carousel.addEventListener('pointercancel', () => {
        pointerStartX = null;
        scheduleAutoplay();
      }, { passive: true });

      carousel.addEventListener('mouseenter', stopAutoplay);
      carousel.addEventListener('mouseleave', scheduleAutoplay);
      carousel.addEventListener('focusin', stopAutoplay);
      carousel.addEventListener('focusout', (event) => {
        if (!carousel.contains(event.relatedTarget)) scheduleAutoplay();
      });

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          inView = entries[0]?.isIntersecting || false;
          if (inView) scheduleAutoplay();
          else stopAutoplay();
        }, { threshold: 0.2 });
        observer.observe(carousel);
      }

      mobileQuery.addEventListener?.('change', () => {
        render();
        scheduleAutoplay();
      });
      document.addEventListener('visibilitychange', scheduleAutoplay);

      render();
      scheduleAutoplay();
      carousel.dataset.iineShowcaseReady = 'true';
    });
  };

  document.addEventListener('DOMContentLoaded', () => initShowcaseStacks());
  document.addEventListener('shopify:section:load', (event) => initShowcaseStacks(event.target));
})();
